<template>

    <div>
        <div class="mt-3">
            <user-search :onSelectUser="select" label="Enter user's email, first name, last name or employer name" searchType="impersonated">
            </user-search>            
        </div>
    </div>

</template>
    
<script>
import store from '../store';
import UserSearch from "../shared/UserSearch";

export default {
  components: { UserSearch },
  data() {
    return {
        buttons: "Close",
        title: "User Selection"
    };
  },
  inject: ['closeModal'],
  methods: {
      async load() {
      },
      async select(result) {
          this.closeModal(result);
      }
  },
  validations() {
  }
};

</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/user/ImpersonationModal.vue